export const SUB_PROJECT_CHANGED = "details/SUB_PROJECT_CHANGED";
export const CUSTOM_DROPDOWN_CHANGED = "details/CUSTOM_DROPDOWN_CHANGED";
export const AGE_RANGES_LOADED = "details/AGE_RANGES_LOADED";
export const AGE_RANGE_CHANGED = "details/AGE_RANGE_CHANGED";
export const AUDIENCE_CHANGED = "details/AUDIENCE_CHANGED";
export const COMPLETE_STEP = "details/COMPLETE_STEP";
export const CONTRIBUTOR_DIALOG_FIELD_BLURRED =
  "details/CONTRIBUTOR_DIALOG_FIELD_BLURRED";
export const CONTRIBUTOR_DIALOG_FIELD_CHANGED =
  "details/CONTRIBUTOR_DIALOG_FIELD_CHANGED";
export const CONTRIBUTOR_DIALOG_ROLE_CHANGED =
  "details/CONTRIBUTOR_DIALOG_ROLE_CHANGED";
export const CONTRIBUTOR_ROLES_LOADED = "details/CONTRIBUTOR_ROLES_LOADED";
export const FIELD_BLURRED = "details/FIELD_BLURRED";
export const FIELD_CHANGED = "details/FIELD_CHANGED";
export const HIDE_CONTRIBUTOR_DIALOG = "details/HIDE_CONTRIBUTOR_DIALOG";
export const HIDE_REMOVE_CONTRIBUTOR_DIALOG =
  "details/HIDE_REMOVE_CONTRIBUTOR_DIALOG";
export const LICENSE_TYPES_LOADED = "details/LICENSE_TYPES_LOADED";
export const LICENSE_TYPE_CHANGED = "details/LICENSE_TYPE_CHANGED";
export const LOCAL_STORAGE_LOADED = "details/LOCAL_STORAGE_LOADED";
export const LOCAL_STORAGE_SYNCED = "details/LOCAL_STORAGE_SYNCED";
export const PRIMARY_CATEGORY_CHANGED = "details/PRIMARY_CATEGORY_CHANGED";
export const REMOVE_CONTRIBUTOR = "details/REMOVE_CONTRIBUTOR";
export const SAVE_ADD_CONTRIBUTOR = "details/SAVE_ADD_CONTRIBUTOR";
export const SAVE_EDIT_CONTRIBUTOR = "details/SAVE_EDIT_CONTRIBUTOR";
export const SECONDARY_CATEGORY_CHANGED = "details/SECONDARY_CATEGORY_CHANGED";
export const SHOW_ADD_CONTRIBUTOR_DIALOG =
  "details/SHOW_ADD_CONTRIBUTOR_DIALOG";
export const SHOW_EDIT_CONTRIBUTOR_DIALOG =
  "details/SHOW_EDIT_CONTRIBUTOR_DIALOG";
export const SHOW_REMOVE_CONTRIBUTOR_DIALOG =
  "details/SHOW_REMOVE_CONTRIBUTOR_DIALOG";
export const TERTIARY_CATEGORY_CHANGED = "details/TERTIARY_CATEGORY_CHANGED";
export const VIDEO_RATINGS_LOADED = "details/VIDEO_RATINGS_LOADED";
export const VIDEO_RATING_CHANGED = "details/VIDEO_RATING_CHANGED";

export const SHOW_REMOVE_TRACK_DIALOG = "details/SHOW_REMOVE_TRACK_DIALOG";
export const HIDE_REMOVE_TRACK_DIALOG = "details/HIDE_REMOVE_TRACK_DIALOG";

export const ADD_EXTERNAL_LINK = "details/ADD_EXTERNAL_LINK";
export const UPDATE_EXTERNAL_LINK = "details/UPDATE_EXTERNAL_LINK";
export const REMOVE_EXTERNAL_LINK = "details/REMOVE_EXTERNAL_LINK";

export const addExternalLink = link => ({ type: ADD_EXTERNAL_LINK, link });

export const updateExternalLink = (index, link) => ({
  type: UPDATE_EXTERNAL_LINK,
  index,
  link,
});

export const removeExternalLink = index => ({
  type: REMOVE_EXTERNAL_LINK,
  index,
});

export const localStorageLoaded = data => ({
  type: LOCAL_STORAGE_LOADED,
  data,
});

export const videoRatingsLoaded = videoRatings => ({
  type: VIDEO_RATINGS_LOADED,
  videoRatings,
});

export const contributorRolesLoaded = contributorRoles => ({
  type: CONTRIBUTOR_ROLES_LOADED,
  contributorRoles,
});

export const licenseTypesLoaded = licenseTypes => ({
  type: LICENSE_TYPES_LOADED,
  licenseTypes,
});

export const ageRangesLoaded = ageRanges => ({
  type: AGE_RANGES_LOADED,
  ageRanges,
});

export const localStorageSynced = () => ({ type: LOCAL_STORAGE_SYNCED });
